import { useSyncExternalStore } from "react";
import { useUIStore, type Theme } from "@/store/ui";

export type ResolvedTheme = "light" | "dark";

const QUERY = "(prefers-color-scheme: dark)";

function subscribe(onChange: () => void): () => void {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
}

const systemIsDark = () => window.matchMedia(QUERY).matches;

export function resolveTheme(theme: Theme, dark = systemIsDark()): ResolvedTheme {
  return theme === "system" ? (dark ? "dark" : "light") : theme;
}

/** The theme actually on screen: the user's choice, or the OS setting for
 *  "system" (updates live when macOS switches between light and dark). */
export function useResolvedTheme(): ResolvedTheme {
  const theme = useUIStore((s) => s.theme);
  const dark = useSyncExternalStore(subscribe, systemIsDark, () => false);
  return resolveTheme(theme, dark);
}
